(() => {
  const el = document.getElementById('qsw');
  if (!el) return;

  const btn = document.getElementById('qsw-btn');
  const fill = document.getElementById('qsw-fill');
  const pct = document.getElementById('qsw-pct');
  const close = document.getElementById('qsw-close');
  if (!btn || !fill || !pct || !close) return;

  const CONFIG = {
    quizUrl: el.dataset.quizUrl || '/pages/take-your-quiz',
    completeAt: el.dataset.anchor || '',
    completeRatio: Number(el.dataset.ratio || 0.65),
    appearAt: Number(el.dataset.appearAt || 0.04),
    stickyReady: true,
  };

  if (btn.getAttribute('href') === '#' || !btn.getAttribute('href')) {
    btn.setAttribute('href', CONFIG.quizUrl);
  }

  const labelIn = el.querySelector('.qsw__label-in');
  let ticking = false;
  let ready = false;
  let last = -1;

  function progress() {
    const vh = window.innerHeight;
    const y = window.pageYOffset || document.documentElement.scrollTop;
    const anchor = CONFIG.completeAt ? document.querySelector(CONFIG.completeAt) : null;
    let end;

    if (anchor) {
      end = y + anchor.getBoundingClientRect().top - vh;
    } else {
      end = (document.documentElement.scrollHeight - vh) * CONFIG.completeRatio;
    }

    if (end <= 0) return 1;
    return Math.min(1, Math.max(0, y / end));
  }

  function paint() {
    ticking = false;
    let p = progress();
    let whole = Math.round(p * 100);

    if (ready && CONFIG.stickyReady) {
      p = 1;
      whole = 100;
    }

    el.setAttribute('data-visible', p >= CONFIG.appearAt || ready ? 'true' : 'false');

    if (whole !== last) {
      last = whole;
      fill.style.strokeDashoffset = String(100 - whole);
      pct.textContent = `${whole}%`;
    }

    if (whole >= 100 && !ready) {
      ready = true;
      el.setAttribute('data-state', 'ready');
      if (labelIn) {
        btn.setAttribute('aria-label', labelIn.textContent.trim());
      }
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'quiz_scroll_prompt_shown' });
      }
    } else if (whole < 100 && ready && !CONFIG.stickyReady) {
      ready = false;
      el.setAttribute('data-state', 'progress');
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(paint);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  close.addEventListener('click', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    el.setAttribute('data-dismissed', 'true');
  });

  btn.addEventListener('click', () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'quiz_scroll_prompt_click' });
    }
  });

  paint();
})();
